import React from 'react';
import BlogArticle from 'components/blog/blogArticle';
import { Post } from 'components/blog/content/styled';
import { authorKalina as author } from 'data/authors';
import img from 'img/blog/conferences-cover.png';

import img1 from 'img/blog/ace.jpeg';
import img2 from 'img/blog/polishopa.png';
import img3 from 'img/blog/productcamp.png';
import img4 from 'img/blog/uxpoland.png';
import img5 from 'img/blog/mobiconf.png';
import img6 from 'img/blog/halodesign.png';
import img7 from 'img/blog/krupa.png';
import img8 from 'img/blog/bydesignconf.png';
import img9 from 'img/blog/webexpo.png';
import img10 from 'img/blog/amuse.png';
import img11 from 'img/blog/uxriga.png';
import img12 from 'img/blog/digitalelitecamp.jpg';
import img13 from 'img/blog/design2020.jpg';
import img14 from 'img/blog/digitallabin.jpg';

const Content = () => {
  return (
    <Post>
      <p>
        <strong>
          Update: As the world turned upside down, we’ve updated our list of UX events in CEE. Check
          the status of all events below!
        </strong>
      </p>
      <p>Last update: 1st June 2020</p>
      <p>The UX scene in Central and Eastern Europe is thriving.</p>
      <p>
        The CEE region is not just a popular IT outsourcing hub – it&#39;s got its own rapidly
        developing UX communities as well.
        <a href="/" target="_blank" rel="noopener noreferrer">
          {' '}
          LiveSession
        </a>{' '}
        itself is living proof, as we&#39;re based in Wrocław, Poland.
      </p>
      <p>
        We&#39;d like to introduce you to top UX events in CEE, from Prague, Bratislava and Budapest
        all the way to Warsaw, Riga and Kyiv. Ready to discover what Central and Eastern Europe has
        to offer in terms of 2020 UX conferences?
      </p>
      <p>Let&#39;s dive in!</p>
      <aside className="blue">
        <h2>We’re here to help</h2>
        <p>
          LiveSession is now <b>50% off</b> for everyone affected by COVID-19. If you’re a{' '}
          <b>non-profit organization</b>, you can get <b>LiveSession for free</b>.
        </p>
        <p>
          Sounds helpful?{' '}
          <b>
            <u>
              <a
                href="https://hello811074.typeform.com/to/hN0CeL"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#000' }}
              >
                Get in touch
              </a>
            </u>{' '}
            for more details
          </b>
          .
        </p>
      </aside>

      <h2 id="quick-access">Quick access</h2>
      <ol>
        <li>
          <p>
            <a href="#uxpoland">UX Events in Poland</a>
          </p>
          <ul>
            <li>
              <a href="#ace-2020">ACE! 2020</a>
            </li>
            <li>
              <a href="#polishopa">POLISHOPA</a>
            </li>
            <li>
              <a href="#productcamp">ProductCamp</a>
            </li>
            <li>
              <a href="#ux-poland">UX Poland</a>
            </li>
            <li>
              <a href="#mobiconf">Mobiconf</a>
            </li>
            <li>
              <a href="#halodesign">Halo Design</a>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <a href="#uxukraine">UX Events in Ukraine</a>
          </p>
          <ul>
            <li>
              <a href="#krupa">Krupa</a>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <a href="#uxslovakia">UX Events in Slovakia</a>
          </p>
          <ul>
            <li>
              <a href="#by-design">By Design Conference</a>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <a href="#uxczech">UX Events in the Czech Republic</a>
          </p>
          <ul>
            <li>
              <a href="#webexpo">WebExpo</a>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <a href="#uxhungary">UX Events in Hungary</a>
          </p>
          <ul>
            <li>
              <a href="#amuse">Amuse UX Conference</a>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <a href="#uxbaltics">UX Events in the Baltics</a>
          </p>
          <ul>
            <li>
              <a href="#ux-riga">UX Riga</a>
            </li>
            <li>
              <a href="#digitalelite">Digital Elite Camp</a>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <a href="#uxcroatia">UX events in Croatia</a>
          </p>
          <ul>
            <li>
              <a href="#design-2020">Design 2020</a>
            </li>
            <li>
              <a href="#digital-labin">Digital Lab.in</a>
            </li>
          </ul>
        </li>
      </ol>
      <h2 id="uxpoland">UX Events in Poland</h2>

      <h3 id="ace-2020">Ace! 2020</h3>

      <p>
        <img
          src={img1}
          alt="ACE! is a two-track product design and agile development conference in Kraków, Poland"
          title="Ace event"
        />
      </p>
      <aside>
        <b>COVID-19 update:</b> The main ACE! conference is moved to 16-18 September. Also, be sure
        to check out their online conference,{' '}
        <a
          href="https://special.aceconf.com/home"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          ACE! without borders.
        </a>
      </aside>

      <p>
        <strong>Where</strong>: Kraków
      </p>
      <p>
        <strong>When</strong>: May 20-22, 2020
      </p>
      <p>
        <strong>Language</strong>: English
      </p>
      <p>
        <a href="https://aceconf.com/home" target="_blank" rel="noopener noreferrer nofollow">
          ACE!
        </a>{' '}
        is a two-track conference dedicated to agile software development and product design. The
        Process track is focused on agile best practices, while the Product segment will include
        inspiring talks from such professionals as{' '}
        <a
          href="https://aceconf.com/speaker/308/alastair-somerville"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          Alastair Somerville
        </a>
        , a sensory design consultant. All presentations will be held in English, and the
        event&#39;s location in Kraków, Poland makes it easily accessible from every part of Europe.
      </p>
      <p>
        <strong>
          <a
            href="https://aceconf.com/buy-tickets/selection"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for ACE! 2020
          </a>
        </strong>
      </p>
      <h3 id="polishopa">POLISHOPA</h3>

      <p>
        <img
          src={img2}
          alt="POLISHOPA is a popular design thinking conference in Bydgoszcz, Poland"
          title="Polishopa event"
        />
      </p>
      <aside>
        <b>COVID-19 update:</b> POLISHOPA has been moved to 21-24 September 2020.
      </aside>

      <p>
        <strong>Where</strong>: Bydgoszcz
      </p>
      <p>
        <strong>When</strong>: June 1-4, 2020
      </p>
      <p>
        <strong>Language:</strong> Polish/English
      </p>
      <p>
        <a href="https://polishopa.pl/en/" target="_blank" rel="noopener noreferrer nofollow">
          POLISHOPA
        </a>{' '}
        is a design thinking conference in Bydgoszcz, Poland. Although you may not have heard of the
        location before, it&#39;s definitely worth stepping off the beaten path! The event will
        leave you inspired with design thinking use cases and best practices. Talks are held in both
        Polish and English. Although this year&#39;s agenda is still in the works, it&#39;s sure to
        be impressive. Last year&#39;s speakers came from international companies like
        Johnson&amp;Johnson and Motorola, as well as Polish giants (Allegro, mBank).
      </p>
      <p>
        <strong>
          <a href="https://polishopa.pl/bilety/" target="_blank" rel="noopener noreferrer nofollow">
            Register for POLISHOPA 2020
          </a>
        </strong>
      </p>
      <h3 id="productcamp">ProductCamp</h3>

      <p>
        <img
          src={img3}
          alt="Product Camp is a prominent digital product conference in Gdynia, Poland"
          title="Product camp event"
        />
      </p>
      <aside>
        <b>COVID-19 update:</b> ProductCamp will take place on 2-4 September, as an{' '}
        <b>online event</b>.
      </aside>

      <p>
        ProductCamp 2020 Online is a 3-day digital event for product people: product managers, UX
        designers, researchers and growth hackers.
      </p>
      <p>
        The Barcamp Day is free. Join and choose from over 50 talks from Digital Product, UX &amp;
        Research professionals such as Zalando, Free Now, OLX,{' '}
        <a href="http://booking.com/" target="_blank" rel="noopener noreferrer nofollow">
          Booking.com
        </a>
        , Oracle, Accenture.
      </p>
      <p>
        Conference line up consists inspirational talks and practical case studies run by
        world-class product leaders such as Laura Klein, Marty Cagan and other great speakers from
        companies like Atlassian, BMW and Flixbus.
      </p>
      <p>
        <a href="https://productcamp.pl" target="_blank" rel="noopener noreferrer nofollow">
          Read more about ProductCamp 2020
        </a>
      </p>
      <h3 id="ux-poland">UX Poland</h3>

      <p>
        <img
          src={img4}
          alt="UX Poland, one of the biggest UX conferences in CEE"
          title="UX Poland event"
        />
      </p>
      <aside>
        <b>COVID-19 update:</b> UX Poland 2020 will take place on October 1-2 as an online event.
        See more{' '}
        <a href="https://uxpoland.com/" target="_blank" rel="noopener noreferrer nofollow">
          on their website
        </a>
        .
      </aside>

      <p>
        <strong>Where</strong>: Warsaw
      </p>
      <p>
        <strong>When</strong>: TBA (usually late September)
      </p>
      <p>
        <strong>Language:</strong> Polish/English
      </p>
      <p>
        One of the most prominent user experience conferences in Europe,
        <a href="https://uxpoland.com/en/" target="_blank" rel="noopener noreferrer nofollow">
          UX Poland
        </a>{' '}
        has been the meeting place for the best professionals in the industry for more than a decade
        now. You can expect to hear valuable insights and case studies from Poland&#39;s top UX
        designers, researchers and other experienced product people. The vast majority of the
        conference is held in Polish.
      </p>
      <p>
        <strong>
          <a
            href="https://uxpoland.com/co-to-jest-ux-poland/"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Read more about UX Poland
          </a>
        </strong>
      </p>
      <h3 id="mobiconf">Mobiconf</h3>

      <p>
        <img
          src={img5}
          alt="Mobiconf, a mobile development conference in Kraków, Poland"
          title="Mobiconf event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: Mobiconf 2020 has been cancelled</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Kraków
      </p>
      <p>
        <strong>When</strong>: October 1-2, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        Connecting mobile designers and developers,{' '}
        <a href="https://2019.mobiconf.org/" target="_blank" rel="noopener noreferrer nofollow">
          Mobiconf
        </a>{' '}
        is a one-of-a-kind event taking place in Kraków, Poland. The 2020 edition is focused not
        only on UX/UI and development but also on project management and challenges that come with
        creating mobile products. Again, the whole conference is in English, and Kraków is a
        beautiful city to visit – a win-win choice!
      </p>
      <p>
        <strong>
          <a
            href="https://www.eventbrite.com/e/mobiconf-registration-61683545144"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for Mobiconf 2020
          </a>
        </strong>
      </p>
      <h3 id="halodesign">Halo Design</h3>

      <p>
        <img
          src={img6}
          alt="Halo Design, a chill UX/UI meetup in Kraków, Poland"
          title="Halo Design event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: There aren’t any Halo Design meetups planned for 2020.</b>
      </aside>

      <p>
        <strong>Where</strong>: Kraków
      </p>
      <p>
        <strong>When</strong>: April 2020 (recurring throughout the year)
      </p>
      <p>
        <strong>Language:</strong> Polish/English
      </p>
      <p>
        Looking for something laid-back yet insightful?{' '}
        <a
          href="https://www.facebook.com/halodesignkrk/"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          Halo Design
        </a>{' '}
        is a chill UX/UI meetup that has already gained a cult status in the Kraków design
        community. Some parts of the event are held in Polish, yet very edition features at least
        one talk in English. Don’t hesitate to join if you’re in town – the tickets are always in
        high demand!
      </p>
      <h2 id="uxukraine">UX Events in Ukraine</h2>

      <h3 id="krupa">Krupa</h3>

      <p>
        <img
          src={img7}
          alt="Krupa, the biggest interface design conference in CEE, takes place in Kyiv"
          title="Krupa event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: Krupa 2020 has been cancelled</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Kyiv
      </p>
      <p>
        <strong>When</strong>: November 20-22, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        Ukraine only has one prominent UX conference – but what a conference it is!{' '}
        <a href="https://prjctr.com.ua/krupa" target="_blank" rel="noopener noreferrer nofollow">
          Krupa
        </a>{' '}
        claims to be the biggest interface design conference in Eastern Europe. The event is held in
        Kyiv and the previous edition included talks from Don Norman, the UX founding father, Vitaly
        Friedman from Smashing Magazine and Guillermo Torres from Airbnb, among others. If this
        doesn&#39;t sound impressive to you, we really don&#39;t know what will!
      </p>
      <h2 id="uxslovakia">UX Events in Slovakia</h2>

      <h3 id="by-design">By Design Conference</h3>

      <p>
        <img
          src={img8}
          alt="By Design Conference is a notable UX design event in Bratislava, Slovakia"
          title="By Design Conference event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: By Design Conference 2020 has been cancelled</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Bratislava
      </p>
      <p>
        <strong>When</strong>: June 6, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        The theme of this year&#39;s{' '}
        <a href="https://bydesignconf.com/" target="_blank" rel="noopener noreferrer nofollow">
          By Design Conference
        </a>{' '}
        is shift by design. Speakers from Spain, Russia, Ukraine and the USA will give talks on how
        to design products for the world in transformation. If you&#39;re into social issues in
        design, Bratislava is the place to be for you this June! The event is quite special, as it
        covers the more human side of UX, design and related fields.
      </p>
      <p>
        <strong>
          <a
            href="https://tickets.bydesignconf.com/?add-to-cart=3086"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for By Design Conference 2020
          </a>
        </strong>
      </p>
      <h2 id="uxczech">UX Events in Czech Republic</h2>

      <h3 id="webexpo">WebExpo</h3>

      <p>
        <img
          src={img9}
          alt="WebExpo is a Prague event for user experience, design and web development professionals"
          title="WebExpo event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: WebExpo 2020 has been cancelled</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Prague
      </p>
      <p>
        <strong>When</strong>: September 18-20, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        A conference with 13 years of history,{' '}
        <a
          href="https://www.webexpo.net/prague2020"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          WebExpo
        </a>{' '}
        is a massive event for everyone involved in creating websites – including, of course, UX
        professionals. It&#39;s a great chance to listen to 70 speakers coming from such companies
        as IBM, Microsoft and the Emirates Group. The topics range from accessibility and design
        patterns to business development and Messenger chatbots. If you&#39;re looking to expand
        your horizons in a wide array of web-related subjects, this is the place to go.
      </p>
      <p>
        <strong>
          <a
            href="https://www.webexpo.net/prague2020/tickets"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for WebExpo 2020
          </a>
        </strong>
      </p>
      <h2 id="uxhungary">UX Events in Hungary</h2>

      <h3 id="amuse">Amuse UX Conference</h3>

      <p>
        <img
          src={img10}
          alt="Amuse UX Conference is the sole big event for user experience professionals in Hungary"
          title="Amuse event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: Amuse UX Conference is not scheduled to take place in 2020</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Budapest
      </p>
      <p>
        <strong>When</strong>: October 16, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        <a href="https://amuseconf.com/" target="_blank" rel="noopener noreferrer nofollow">
          Amuse
        </a>{' '}
        is the only UX conference in Hungary. Although the 2020 agenda is not available yet, the one
        from the previous edition gives us high expectations for this year. The list included
        speakers from Google, Booking.com, Shopify, YouTube, UXPin and Facebook – to name just a few
        of the most prominent examples! Budapest is easy to reach from every part of Europe (and
        many places of the Middle East too) – why not give it a try?
      </p>
      <h2 id="uxbaltics">UX Events in the Baltics</h2>

      <h3 id="ux-riga">UX Riga</h3>

      <p>
        <img
          src={img11}
          alt="UX Riga is the biggest UX conference in Latvia and in all Baltic countries"
          title="UX Riga event"
        />
      </p>
      <aside>
        <b>COVID-19 update:</b> UX Riga will take place! Stay tuned as the team is making a decision
        on the final format.
      </aside>

      <p>
        <strong>Where</strong>: Riga, Latvia
      </p>
      <p>
        <strong>When</strong>: TBA
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        <a href="https://www.uxriga.com/" target="_blank" rel="noopener noreferrer nofollow">
          UX Riga
        </a>{' '}
        will take place for the 7th time in 2020. It&#39;s the largest user experience conference
        not only in Latvia but also in all Baltic states. Speakers of the last edition included Mike
        Dick from Survey Monkey, Vitaly Friedman from Smashing Magazine and Jim Kalbach, a notable
        O&#39;Reilly author. This year&#39;s agenda is still in the making and we&#39;re excited to
        see what&#39;s to come!
      </p>
      <h3 id="digitalelite">Digital Elite Camp</h3>

      <p>
        <img
          src={img12}
          alt="Digital Elite Camp is a unique growth hacking event in Estonia"
          title="Digital Elite Camp event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: Digital Elite Camp 2020 is cancelled</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Laulasmaa, Estonia
      </p>
      <p>
        <strong>When</strong>: June 11-13, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        Although not exactly a UX conference,{' '}
        <a href="https://digitalelitecamp.com/" target="_blank" rel="noopener noreferrer nofollow">
          Digital Elite Camp
        </a>{' '}
        is a great pick for those interested in growth hacking and CRO. The concept and the location
        make it particularly tempting – why not spend three days on the Baltic coast (four days,
        including the pre-party) and learn best practices from top growth professionals? SPAs,
        saunas and lots of top-notch knowledge are included. This year&#39;s line-up includes Peep
        Laja, the CEO and Founder of{' '}
        <a href="https://cxl.com/" target="_blank" rel="noopener noreferrer nofollow">
          CXL Institute
        </a>
        . More big names are going to be announced soon. So, destination: Estonia?
      </p>
      <p>
        <strong>
          <a
            href="https://fienta.com/elite-camp-2020?_ga=2.188410024.1825507888.1581691381-2081637298.1581512917"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for Digital Elite Camp 2020
          </a>
        </strong>
      </p>
      <h2 id="uxcroatia">UX Events in the Croatia</h2>

      <h3 id="design-2020">Design 2020</h3>

      <p>
        <img
          src={img13}
          alt="Hosted in Cavtat, Croatia, Design 2020 is a big conference on all things design"
          title="Design 2020 event"
        />
      </p>
      <aside>
        <b>COVID-19 update:</b> Design 2020 has been postponed to October 26-29.
      </aside>

      <p>
        <strong>Where</strong>: Cavtat
      </p>
      <p>
        <strong>When</strong>: May 18-21, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        If you&#39;d like to take part in a comprehensive design conference,{' '}
        <a
          href="https://www.designconference.org/"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          Design 2020
        </a>{' '}
        is what you&#39;re looking for. The agenda will cover a wide range of topics, from theory,
        methods and processes to behavioral sciences, engineering and industrial design. And the
        cherry on top? The venue is Hotel Croatia Cavtat, a luxury building on the Adriatic coast,
        just a short drive from Dubrovnik. What&#39;s not to love?
      </p>
      <p>
        <strong>
          <a
            href="https://www.designconference.org/registration"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for Design 2020
          </a>
        </strong>
      </p>
      <h3 id="digital-labin">Digital Lab.in</h3>

      <p>
        <img
          src={img14}
          alt="Digital Lab.in is a Croatian UX conference, hosted on the Istria Peninsula"
          title="Digital Lab.in event"
        />
      </p>
      <aside className="red">
        <b>COVID-19 update: Digital Lab.in 2020 has been cancelled</b>{' '}
        <span role="img" aria-label="emoji">
          😔
        </span>
      </aside>

      <p>
        <strong>Where</strong>: Labin
      </p>
      <p>
        <strong>When</strong>: September 25-26, 2020
      </p>
      <p>
        <strong>Language:</strong> English
      </p>
      <p>
        Located on the scenic Istrian Peninsula, Labin plays host to{' '}
        <a href="https://digitalab.in/" target="_blank" rel="noopener noreferrer nofollow">
          Digital Lab.in
        </a>
        ,Croatia&#39;s biggest UX conference. Every year, it involves talks from top design and
        developments professionals. Speakers are coming from top-tier companies like Booking.com and
        Google. The conference&#39;s stunning seaside location is an additional asset!
      </p>
      <p>
        <strong>
          <a
            href="https://digitalab.in/get-tickets"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Register for Digital Lab.in 2020
          </a>
        </strong>
      </p>
      <p>
        We did our best to list <em>all</em> the interesting UX conferences in CEE. Still, if we
        missed something, don&#39;t hesitate to <strong>let us know in the comments</strong>!
      </p>
    </Post>
  );
};

const Wrapped = BlogArticle(Content);

export const frontmatter = {
  title: 'UX Events in CEE – 2020 Edition (COVID-19 Update)',
  url: '/blog/top-ux-events-in-cee/',
  description: `Check out the best UX events in Central and Eastern Europe, from Slovakia and Poland to Croatia and Ukraine. See the latest changes and updates!`,
  author,
  img,
  imgSocial: img,
  date: '2020-06-01',
  category: '',
  group: 'Design',
  timeToRead: 9,
};

export default () => (
  <Wrapped
    title={frontmatter.title}
    category={frontmatter.category}
    description={frontmatter.description}
    date={frontmatter.date}
    author={frontmatter.author}
    url={frontmatter.url}
    img={frontmatter.img}
    imgSocial={process.env.GATSBY_HOST + frontmatter.img}
    group={frontmatter.group}
    timeToRead={frontmatter.timeToRead}
  />
);
